import TrainingsBlock from "./TrainingsBlock";

export default TrainingsBlock;
